/**
 * [API] 메인
 * @module @apis/home
 */

import axios from '@/user/apis/common/axios-handle-error.service'

/**
 * 교육 목록
 * @method getPrimaryLectures
 * @returns {promise} {data} = response or error
 */
export const getPrimaryLectures = () => {
  return new Promise((resolve, reject) => {
    const url = `/api/lecture/v1/primary-lectures`
    return axios
      .get(url)
      .then(({ data }) => resolve(data))
      .catch(reject)
  })
}

/**
 * 활성화된 레벨별 교육 목록
 * @method getActivatedLectures
 * @returns {promise} {data} = response or error
 */
export const getActivatedLectures = (level, size) => {
  return new Promise((resolve, reject) => {
    const url = `/api/lecture/v1/primary-lectures/${level}?size=${size}`
    return axios
      .get(url)
      .then(({ data }) => resolve(data))
      .catch(reject)
  })
}

export const HomeService = {
  getPrimaryLectures,
  getActivatedLectures,
}
